import React from 'react';
import classNames from 'classnames';

export default function PhoneIcon({ className = '' }) {
	return <span className={classNames('icon icon-call_alt', className)} />;
}
